import styles from './Checkbox.module.css';

function Checkbox({ id, label, checked, onChange }) {
  return (
    <div className={`${styles.wrapper} form-check mb-0`}>
      <input
        id={id}
        type="checkbox"
        className={`${styles.input} form-check-input`}
        checked={checked}
        onChange={onChange}
      />
      <label htmlFor={id} className={`${styles.label} form-check-label`}>
        {label}
      </label>
    </div>
  );
}

export default Checkbox;
